import * as KatalMetrics from '@amzn/katal-metrics';

export type Cohort = 'Whale' | 'NonWhale';

export const toCohort = (isWhale: boolean | undefined): Cohort | undefined =>
  isWhale === undefined ? undefined : isWhale ? 'Whale' : 'NonWhale';

export const cohortSuffix = (
  cohort: Cohort | undefined,
): '' | '.Whale' | '.NonWhale' => (cohort === undefined ? '' : `.${cohort}`);

export const publishCohortCounter = (
  publisher: KatalMetrics.Publisher,
  base: string,
  cohort: Cohort | undefined,
): void => {
  publisher.publishCounterMonitor(base, 1);
  if (cohort !== undefined) {
    publisher.publishCounterMonitor(`${base}${cohortSuffix(cohort)}`, 1);
  }
};

export const cohortDetail = (
  cohort: Cohort | undefined,
): { cohort?: Cohort } => (cohort === undefined ? {} : { cohort });
